import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { CloseIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import { primaryColorAlternative } from '@calendly/ui/theme';
import classNames from 'classnames';
import { useEffect, useRef, forwardRef } from 'react';
const containerCss = "cn3wqbt";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const editLinkCss = "eto15u9";
const EditLink = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(editLinkCss, props.className)} />);
const closeButtonCss = "crpn3tz";
const CloseButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(closeButtonCss, props.className)} />);
export const Controls = ({
  isNewlyAddedLocation,
  onEdit,
  onClose
}) => {
  const ref = useRef();
  useEffect(() => {
    if (isNewlyAddedLocation) {
      ref.current.focus();
    }
  }, [isNewlyAddedLocation]);
  return <Container>
      <EditLink ref={ref} onClick={onEdit}>
        <BodyText size="medium" color={primaryColorAlternative}>
          {I18n.t('publisher.event_types.location.edit')}
        </BodyText>
      </EditLink>
      <CloseButton aria-label={I18n.t('publisher.action.remove')} onClick={onClose}>
        <CloseIcon />
      </CloseButton>
    </Container>;
};

require("./controls.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./controls.js");